import React from "react"
import PropTypes from "prop-types"
import { withTranslation } from "react-i18next"
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Col,
  Row,
  Spinner,
} from "reactstrap"
import { useAPI } from "hooks/useAPI"
import ReactApexChart from "react-apexcharts"
import getChartColorsArray from "components/Common/ChartsDynamicColor"
import { isNumber } from "lodash"
import { useIndicadoresFiltrosStore } from "store/useIndicadoresFiltrosStore"

const EntregaTransp = props => {
  const REPORT_ID = 3

  const fetchReports = useIndicadoresFiltrosStore(state => state.fetchReports)
  const filtrosSelecionados = useIndicadoresFiltrosStore(
    state => state.filtrosSelecionados
  )

  const { payload, error, isLoading } = useAPI(
    REPORT_ID,
    filtrosSelecionados,
    fetchReports
  )

  const columns = payload?.data?.columns[0]
    .filter((item, idx) => idx > 0)
    .map(item => {
      return item !== null ? item : ""
    })

  const series = [
    {
      name: payload?.data?.columns[1][0],
      data: payload?.data?.columns[1].filter(item => isNumber(item)),
    },
  ]

  const chartOptions = {
    chart: {
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: true,
      },
    },
    dataLabels: {
      enabled: true,
    },
    colors: getChartColorsArray('["--bs-success"]'),
    grid: {
      borderColor: "#f1f1f1",
    },
    xaxis: {
      categories: columns,
    },
  }

  return (
    <Card>
      <CardHeader tag={"h4"} className="bg-transparent border-bottom">
        {!isLoading && payload?.title}
        {isLoading && <span className="placeholder col-3"></span>}
      </CardHeader>
      <CardBody>
        <Row>
          <Col>
            {isLoading && (
              <div className="mt-3" style={{ textAlign: "center" }}>
                <Spinner
                  className="ms-2"
                  style={{ width: "4rem", height: "4rem" }}
                  color="primary"
                />
              </div>
            )}
            {!isLoading &&
              (series[0].data?.length > 0 ? (
                <ReactApexChart
                  options={chartOptions}
                  series={series}
                  type="bar"
                  height={600}
                  className="apex-charts"
                ></ReactApexChart>
              ) : (
                <CardTitle className="text-center">
                  Nenhum dado foi encontrado.
                </CardTitle>
              ))}
          </Col>
        </Row>
      </CardBody>
    </Card>
  )
}

EntregaTransp.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(EntregaTransp)
